var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8983 42.422L22.3987 36.9617V29.6814C22.3987 25.4812 21.5587 21.561 19.8786 17.9208C18.1052 14.2807 15.8184 10.9672 13.0183 7.98037C10.2182 4.99357 7.1847 2.33345 3.91788 0C3.17117 0.466688 2.51781 1.02672 1.95779 1.68008C1.39776 2.24011 0.931069 2.98681 0.557718 3.92018C3.17117 6.25363 5.50462 8.68041 7.55805 11.2005C9.51814 13.7206 11.0115 16.4274 12.0383 19.3209L1.39776 24.6412V36.9617L11.8983 42.422ZM38.4995 42.422L49 36.9617V29.6814C49 25.4812 48.16 21.561 46.4799 17.9208C44.7065 14.2807 42.4197 10.9672 39.6196 7.98037C36.8194 4.99357 33.7859 2.33345 30.5191 0C29.7724 0.466688 29.1191 1.02672 28.559 1.68008C27.999 2.24011 27.5323 2.98681 27.159 3.92018C29.7724 6.25363 32.1059 8.68041 34.1593 11.2005C36.1194 13.7206 37.6128 16.4274 38.6395 19.3209L27.999 24.6412V36.9617L38.4995 42.422Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightQuote);
export default __webpack_public_path__ + "static/media/right-quote.df67b48e25005da15a6ba56a18fa5753.svg";
export { ForwardRef as ReactComponent };